import React, { useState, useRef, useEffect } from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";

const EmpSettingsPage = () => {

  const navigate = useNavigate();
  const savedColor = localStorage.getItem("navbarColor") || "#080235";

  const [tempColor, setTempColor] = useState(savedColor);
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );
  const [collapseSidebar, setCollapseSidebar] = useState(
    localStorage.getItem("collapseSidebar") === "true"
  );

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);

  const colorOptions = [
    { name: "Default Blue", value: "#080235" },
    { name: "Black", value: "#000000" },
    { name: "Dark Gray", value: "#343a40" },
    { name: "Gray", value: "#6c757d" },
    { name: "Light Gray", value: "#adb5bd" },
    { name: "Green", value: "#198754" },
    { name: "Light Green", value: "#28a745" },
    { name: "Teal", value: "#20c997" },
    { name: "Cyan", value: "#17a2b8" },
    { name: "Sky Blue", value: "#87CEEB" },
    { name: "Blue", value: "#0d6efd" },
    { name: "Indigo", value: "#6610f2" },
    { name: "Purple", value: "#6f42c1" },
    { name: "Pink", value: "#d63384" },
    { name: "Red", value: "#dc3545" },
    { name: "Orange", value: "#fd7e14" },
    { name: "Yellow", value: "#ffc107" },
    { name: "Lime", value: "#cddc39" },
    { name: "Brown", value: "#795548" },
    { name: "Maroon", value: "#800000" },
    { name: "Olive", value: "#808000" },
    { name: "Navy", value: "#000080" },
    { name: "Magenta", value: "#ff00ff" },
    { name: "Violet", value: "#8a2be2" },
    { name: "Turquoise", value: "#40e0d0" },
    { name: "Coral", value: "#ff7f50" },
    { name: "Salmon", value: "#fa8072" },
    { name: "Gold", value: "#ffd700" },
    { name: "Silver", value: "#c0c0c0" },
    { name: "Bronze", value: "#cd7f32" },
    { name: "Sky Gray", value: "#b0c4de" },
    { name: "Mint", value: "#98ff98" },
    { name: "Peach", value: "#ffe5b4" },
    { name: "Cream", value: "#fffdd0" },
    { name: "Brick", value: "#b22222" },
    { name: "Persimmon", value: "#e5772a" },
    { name: "Slate Blue", value: "#607799" },
    { name: "Light Sky Blue", value: "#87cefa" },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");

    if (!token) {
      toast.error("You must be logged in.");
      navigate("/");
    }

    if (!roles.includes("ROLE_USER")) {
      toast.error("Unauthorized access.");
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (dropdownRef.current) {
      setDropdownWidth(dropdownRef.current.offsetWidth);
    }
  }, []);

  const handleColorSelect = (color) => {
    setTempColor(color);
    setDropdownOpen(false);
  };

  const handleSave = () => {

    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    fetch(`${API_BASE_URL}/api/appearance/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        userId: userId,
        navbarColor: tempColor
      })
    })
      .then(res => res.json())
      .then(() => {
        toast.success("Appearance saved successfully");

        setTimeout(() => {
          window.location.reload();
        }, 800);
      })
      .catch(() => {
        toast.error("Error saving appearance");
      });

  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCancel = () => {
    setTempColor(savedColor);
    setDarkMode(localStorage.getItem("darkMode") === "true");
    setCollapseSidebar(localStorage.getItem("collapseSidebar") === "true");
    navigate(-1);
  };

  return (
    <>
      <div className="fixed-top">
        <EmployeeNavbar />
      </div>

      <div className="container-fluid preference-page px-5" style={{ paddingTop: "40px" }}>

        <h3 className="fw-bold">Preferences</h3>

        <div className="mb-4 mt-2">
          <button className="btn btn-primary me-2" onClick={handleSave}>
            Save
          </button>

          <button className="btn btn-secondary btn-sm" onClick={handleCancel}>
            Cancel
          </button>
        </div>

        <div className="row g-4">

          {/* Appearance */}
          <div className="col-lg-4 col-md-6">
            <div className="card preference-card h-100">

              <h5 className="section-title">🎨 Appearance</h5>

              <div ref={dropdownRef} className="position-relative">

                <label className="form-label fw-semibold">
                  Choose Color
                </label>

                <div
                  className="form-control dropdown-select"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      className="color-dot"
                      style={{ backgroundColor: tempColor }}
                    ></span>

                    {colorOptions.find(c => c.value === tempColor)?.name}
                  </div>

                  <span>{dropdownOpen ? "▲" : "▼"}</span>
                </div>

                {dropdownOpen && (
                  <div
                    className="dropdown-menu-custom"
                    style={{ width: dropdownWidth }}
                  >
                    {colorOptions.map((color) => (
                      <div
                        key={color.value}
                        className="dropdown-item-custom"
                        onClick={() => handleColorSelect(color.value)}
                      >
                        <span
                          className="color-dot"
                          style={{ backgroundColor: color.value }}
                        ></span>

                        {color.name}
                      </div>
                    ))}
                  </div>
                )}

                <div className="mt-3">
                  <label className="form-label fw-semibold">
                    Custom Color
                  </label>

                  <input
                    type="color"
                    className="form-control form-control-color"
                    value={tempColor}
                    onChange={(e) => setTempColor(e.target.value)}
                    title="Choose your color"
                  />
                </div>

              </div>

              {/* <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={darkMode}
                  onChange={(e) => setDarkMode(e.target.checked)}
                />
                <label className="form-check-label">
                  Enable Dark Mode
                </label>
              </div> */}

            </div>
          </div>


          {/* Layout */}
          <div className="col-lg-4 col-md-6">
            <div className="card preference-card h-100">

              <h5 className="section-title">🖥 Layout</h5>

              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={collapseSidebar}
                  onChange={(e) =>
                    setCollapseSidebar(e.target.checked)
                  }
                />
                <label className="form-check-label">
                  Enable layout settings
                </label>
              </div>

            </div>
          </div>


          {/* Notifications */}
          <div className="col-lg-4 col-md-6">
            <div className="card preference-card h-100">

              <h5 className="section-title">🔔 Notifications</h5>

              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" />
                <label className="form-check-label">
                  Enable System Notifications
                </label>
              </div>

            </div>
          </div>

        </div>


        {/* Buttons */}
        {/* <div className="mt-4">
          <button className="btn btn-primary me-2" onClick={handleSave}>
            Save
          </button>

          <button className="btn btn-secondary" onClick={handleCancel}>
            Cancel
          </button>
        </div> */}

      </div>

      <style>{`

.preference-page{
margin-top:100px;
width:100%;
}

.preference-card{
padding:22px;
border-radius:12px;
box-shadow:0 4px 14px rgba(0,0,0,0.08);
transition:all 0.2s ease;
}

.preference-card:hover{
transform:translateY(-3px);
box-shadow:0 6px 20px rgba(0,0,0,0.12);
}

.section-title{
margin-bottom:15px;
font-weight:600;
}

.dropdown-select{
display:flex;
justify-content:space-between;
align-items:center;
cursor:pointer;
}

.dropdown-menu-custom{
position:absolute;
background:white;
border:1px solid #ddd;
box-shadow:0 2px 10px rgba(0,0,0,0.1);
max-height:200px;
overflow-y:auto;
z-index:1000;
}

.dropdown-item-custom{
padding:8px 12px;
display:flex;
align-items:center;
cursor:pointer;
}

.dropdown-item-custom:hover{
background:#f3f3f3;
}

.color-dot{
width:14px;
height:14px;
border-radius:50%;
margin-right:8px;
display:inline-block;
}

`}</style>
    </>
  );
};

export default EmpSettingsPage;